import { Injectable } from '@angular/core';
import { AppStore } from '../app-store/app-store.service';

@Injectable({
  providedIn: 'root',
})
export class IframeAdapterService {
  domainRef = 'https://www.bci.cl';
  constructor(private appStore: AppStore) {
    this.domainRef = this.appStore.env.domainRef;
  }
  iframeAdjustement(scroll = false) {
    setTimeout(() => {
      const windowInnerH = window.innerHeight;

      if (window.MessageChannel === undefined) {
        console.error('Navegador no habilitado para ajuste');
      } else {
        const mc = new MessageChannel();
        const data = {
          height: windowInnerH,
          scroll: scroll,
        };
        window.parent.postMessage(data, this.domainRef, [mc.port1]);
      }
    }, 400);
  }
}
